import { useState, useEffect } from "react";

// True on phones + tablets / narrow PWA windows (below the `lg` breakpoint).
// Reactive to viewport changes (rotation, resize, PWA window).
export function useIsMobile(query = "(max-width: 1023px)") {
  const get = () => (typeof window !== "undefined" ? window.matchMedia(query).matches : false);
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const on = () => setIsMobile(mql.matches);
    on();
    mql.addEventListener("change", on);
    return () => mql.removeEventListener("change", on);
  }, [query]);
  return isMobile;
}

export default useIsMobile;
